module.exports = __webpack_public_path__ + "static/media/infinity-solid.fd4ea03a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/infinity-solid.svg
// module id = 39
// module chunks = 0